/**
 * @author gyb(mocheer)
 * @since 2018-8-3
 */
let imgs = {};
export default url => imgs[url] = imgs[url] || (function () {
  let funcs = [];
  let img = new Image();
  let complete = false;
  let loader = imgs[url] = {
    then: func => {
      complete ? func(img) : funcs.push(func);
    }
  };
  img.src = url;
  img.onload = () => {
    complete = true;
    while (funcs.length > 0) {
      funcs.shift()(img)
    }
  }
  return loader;
})()


/**
 * 弃用
 * ie下，基于 polyfill 的 promise 太影响性能。
 */
// export default url => imgs[url] = imgs[url] || new Promise(reject => {
//   let img = new Image();
//   img.src = url;
//   // 加载src资源时 complete 为true,即使图片尚未加载
//   // img.addEventListener('load', e => {
//   //   reject(img);
//   // })
//   img.onload = e => { reject(img) }
// })


// WEBPACK FOOTER //
// ./src/utils/Loader.js